var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1440_7499",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1440_7499",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAABjklEQVR4nO3YvUoDQRSG4W+CTQKi96e9thbiRdj5A7ENensmhWgh+FkopIi4c4wzu7P7PvWwHM4uDPtKAAAAAAAA45FyDtleSLqWdCLpqOhE7dhIepJ0mVJ66zqcu+ilpLM9Bxurh5TSedehzkXbnkl6kTT/j6lG6FXSYUrp47dDs0rDTF7nor/f1KrCLK1adX3NknSQ+bALSe+STiUd7zPViKwlPUq66nsQAACALVrHVqhdRNE6dmW1iyhax66sdhFF66iE1rErq11E0Tq2aBcAAGAqbC9s39veuB1r23e22/mjtb3seWn7WPa9P2karaNIu4iidVQyhdZRpF1Ejbl10C4AAAB+5mG0jvbaRZSH1ToG0S6iWmwdg2gXUbSOSlpsHYNoF0XYntu+9deF1Jdn2zce82UIAABQh8u0jvG3iyiXbR1NtouoIbSOJttFFK2jkiG0jvG2iyiXaR20CwAAgH44r3XQLvblWOuYRLuIKtE6JtEuomgdlZRoHbSLv3Je66BdAAAAAAAATMQn7ZoffqsmkM4AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/Sorting.db76a66b9071e00ea8cafc639b91b910.svg";
export { ForwardRef as ReactComponent };